import { auth } from '../../../auth';
import { createThunk } from '../../../redux';
import { getLeaveOrganizationApiUrl } from '../../../redux/modules/accountApis';
import { settingsManager } from '../../../shared/settings';
import { actionLeaveOrgError, actionLeaveOrgSuccess } from '../actions';
import 'whatwg-fetch';

export const effectLeaveOrgFetch = createThunk(
  async (dispatch, _getState) => {
    const clientId = settingsManager.getRequired('clientId');
    const token = await auth.acquireToken({ scopes: [clientId] });
    const tenantId = auth.user?.tenantId;

    const baseUrl = getLeaveOrganizationApiUrl(tenantId ?? '');
    const response = await fetch(baseUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      dispatch(actionLeaveOrgSuccess());
    } else {
      throw Error(`invalid response from POST ${response.url}`);
    }
  },
  (error, dispatch) => {
    dispatch(actionLeaveOrgError(error));
  },
);
